function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import { assetPath, translate, translateFieldName, getCartLocalStorage, setCartLocalStorage } from '../utils/helpers';
import PropTypes from 'prop-types';
import { API_URL, LANG } from '../utils/constant';

var AddCartModal = /*#__PURE__*/function (_Component) {
  _inherits(AddCartModal, _Component);

  var _super = _createSuper(AddCartModal);

  function AddCartModal(props) {
    var _this;

    _classCallCheck(this, AddCartModal);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "fetchProduct", function (slug) {
      fetch(API_URL + '/products/slug/' + slug + '.json', {
        mode: 'cors'
      }).then(function (data) {
        return data.json();
      }).then(function (product) {
        _this.setState({
          product: product
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "updateCart", function (product, quantity, variation, cart) {
      var _product = product;
      _product.quantity = quantity;
      _product.selectedVariation = variation === null ? {
        id: 0,
        noVariation: true,
        name_en: '',
        name_fr: ''
      } : variation;
      _product.uniqId = _product.id + '+uniq' + _product.selectedVariation.id;
      var _cart = cart;
      var index = cart.findIndex(function (item) {
        return item.uniqId === _product.uniqId;
      });

      if (index === -1) {
        _cart.push(_product);
      } else {
        _cart[index].quantity += quantity;
      }

      return _cart;
    });

    _defineProperty(_assertThisInitialized(_this), "updateInputValue", function (event) {
      _this.setState({
        inputValue: event.target.value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onChangeQuantity", function (event) {
      var inputValue = event.target.value; //return false if the value typed by user is not a number

      if (!event.target.validity.valid) {
        return false;
      } //return false if the value typed by user is superior to its max attribute


      if (parseInt(event.target.value, 10) > parseInt(event.target.max, 10)) {
        return false;
      }

      if (parseInt(event.target.value, 10) === 0) {
        inputValue = 1;
      }

      _this.setState({
        inputValue: inputValue
      });
    });

    _defineProperty(_assertThisInitialized(_this), "addToCart", function () {
      _this.setState({
        disabled: true
      });

      var selectedIndex = _this.variationRef.current !== null ? _this.variationRef.current.selectedIndex : 0;

      var _variation = _this.state.product.formats.length ? _this.state.product.formats[selectedIndex] : null;

      var myCart = getCartLocalStorage();
      myCart = _this.updateCart(_this.props.product, parseInt(_this.quantityRef.current.value, 10), _variation, myCart);
      setCartLocalStorage(myCart);
      setTimeout(function () {
        if (_this._isMounted) _this.setState({
          disabled: false,
          inputValue: 1
        });
      }, 1000);

      _this.props.closeModal();
    });

    _defineProperty(_assertThisInitialized(_this), "getDeleteIcon", function () {
      return document.querySelector('#shop-page').getAttribute('cross');
    });

    _this.state = {
      inputValue: 1,
      product: {},
      disabled: false
    };
    _this._isMounted = false;
    _this.quantityRef = /*#__PURE__*/React.createRef();
    _this.variationRef = /*#__PURE__*/React.createRef();
    return _this;
  }

  _createClass(AddCartModal, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      this._isMounted = true;

      if (prevProps.product !== this.props.product) {
        this.fetchProduct(this.props.product.slug);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var product = this.props.product;
      var inputValue = this.state.inputValue;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "modal fade",
        id: "ModalAddToCart",
        tabIndex: "-1",
        role: "dialog",
        "aria-labelledby": "exampleModalCenterTitle",
        "aria-hidden": "true",
        onClick: this.props.closeModalOut
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-dialog modal-dialog-centered",
        role: "document"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-content",
        id: "modal-content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "delete",
        "data-dismiss": "modal",
        onClick: this.props.closeModal
      }, /*#__PURE__*/React.createElement("img", {
        src: this.getDeleteIcon(),
        alt: "delete icon"
      })), /*#__PURE__*/React.createElement("div", {
        className: "modal-header"
      }, /*#__PURE__*/React.createElement("h1", {
        className: "modal-title main-bg-after",
        id: "exampleModalLongTitle"
      }, translate('Add to quote', 'Ajouter au panier'))), /*#__PURE__*/React.createElement("div", {
        className: "content-box"
      }, /*#__PURE__*/React.createElement("div", {
        className: "product-description first-uppercase d-flex flex-row"
      }, product.product_photos && product.product_photos[0].photo.thumb.url !== null ? /*#__PURE__*/React.createElement("div", {
        className: "col-6 product-image"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          backgroundImage: 'url(' + assetPath(product.product_photos[0].photo.thumb.url) + ')'
        }
      })) : null, /*#__PURE__*/React.createElement("div", {
        className: "col-6 details d-flex flex-column"
      }, /*#__PURE__*/React.createElement("div", {
        className: "product-title"
      }, /*#__PURE__*/React.createElement("div", {
        className: "brand uppercase"
      }, product.supplier && product.supplier[translateFieldName('name')]), product.slug !== null ?
      /*#__PURE__*/
      // <Link
      //   to={`/product/${product.slug}`}
      //   className="code uppercase  main-txt-hover"
      // >
      //   {product[translateFieldName('code')]}
      // </Link>
      React.createElement("a", {
        href: "/".concat(LANG, "/product/").concat(product.slug),
        className: "code uppercase  main-txt-hover"
      }, product[translateFieldName('code')]) : /*#__PURE__*/React.createElement("div", {
        className: "code uppercase"
      }, product[translateFieldName('code')])), /*#__PURE__*/React.createElement("span", {
        className: "name"
      }, product[translateFieldName('name')]))), /*#__PURE__*/React.createElement("div", {
        className: "product-card-bottom"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row w-100 mb-4 add-box"
      }, this.state.product.formats && this.state.product.formats.length > 0 && this.state.product.formats[0][translateFieldName('name')] !== '' ? /*#__PURE__*/React.createElement("div", {
        className: "format"
      }, /*#__PURE__*/React.createElement("span", null, this.state.product.variation[translateFieldName('name')].toUpperCase()), this.state.product.formats.length > 1 ? /*#__PURE__*/React.createElement("select", {
        ref: this.variationRef
      }, this.state.product.formats.map(function (format) {
        return /*#__PURE__*/React.createElement("option", {
          key: format.id,
          value: format.code
        }, format[translateFieldName('name')]);
      })) : /*#__PURE__*/React.createElement("div", null, this.state.product.formats[0][translateFieldName('name')])) : null, /*#__PURE__*/React.createElement("div", {
        className: "qty"
      }, /*#__PURE__*/React.createElement("div", {
        className: "qte-box uppercase"
      }, translate('Quantity', 'Quantité'), /*#__PURE__*/React.createElement("input", {
        ref: this.quantityRef,
        type: "text",
        min: "1",
        value: inputValue,
        max: 10000,
        pattern: "[0-9]*",
        onBlur: function onBlur(event) {
          var inputValue = event.target.value;

          if (event.target.value === '') {
            inputValue = 1;
          }

          _this2.setState({
            inputValue: inputValue
          });
        },
        onChange: this.onChangeQuantity
      })))), /*#__PURE__*/React.createElement("div", {
        className: "row w-100 justify-content-center"
      }, /*#__PURE__*/React.createElement("button", {
        className: "btn main-border uppercase",
        "data-toggle": "modal",
        "data-target": "#exampleModalCenter",
        "data-backdrop": "false",
        onClick: this.addToCart,
        disabled: this.state.disabled
      }, this.state.disabled ? translate('Added ', 'Ajouté') : translate('Add to quote', 'Ajouter au panier')))))))));
    }
  }]);

  return AddCartModal;
}(Component);

AddCartModal.propTypes = {
  product: PropTypes.object,
  activeBackDrop: PropTypes.bool,
  closeModal: PropTypes.func,
  closeModalOut: PropTypes.func,
  getDeleteIcon: PropTypes.func
};
export default AddCartModal;